import P from '../../pages';
import React from 'react';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import Button from 'react-bootstrap/lib/Button';
import Form from 'react-bootstrap/lib/Form';
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import SelectGroup from './SelectGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import Alert from './Alert';
import Home from 'react-icons/lib/md/home';
import ButtonGroup from './ButtonGroup';
import CustomFormGroup from './CustomFormGroup';
import ProfileElementField from './ProfileElementField';
import { validator, fieldsToValidate, pageValid, executeValidations, shouldValidateProfileElement, toggleValidations } from '../../validator';
import { generateProfileElementObject, setProfileElementsFromState, handleSelection, changeState } from '../../utilities';

class House extends React.Component {
  constructor(props){
    super(props);
    let featureSelections = this.props.localProfileElements.elements.home.feature_selections
    let features = setProfileElementsFromState(this.props.profileElements, [], 'home', 'features').filter(f => featureSelections.flat().includes(f))
    let featuresOther = setProfileElementsFromState(this.props.profileElements, '','home','features_other')
    let validateFeatures = shouldValidateProfileElement(this, 'features')
    let validateFeaturesOther = validateFeatures && features.includes('Other')
    this.state = {
      buildingType: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','home','building_type'),
      features: { val: features, validationKey: validateFeatures ? 'profile_elements_home_features' : '' },
      featuresOther: { val: featuresOther, validationKey: validateFeaturesOther ? 'profile_elements_home_features_other' : '' },
      featureSelections: featureSelections,
      buildingTypeSelections: this.props.localProfileElements.elements.home.building_type_selections
    };
    this.submit = this.submit.bind(this);
    this.changeState = this.changeState.bind(this);
    this.handleFeature = this.handleFeature.bind(this);
  }

  componentWillMount(){
    executeValidations(this)
  }

  changeState = async(id, val) => {
    if (id == 'features'){
      toggleValidations(this, val.includes('Other'), 'features', 'featuresOther', 'profile_elements_home_features_other')
    }
    changeState(this, id, val)
  }

  handleFeature(e){
    this.changeState('features', handleSelection(this.state.features.val, e.target.value))
  }

  submit(e) {
    this.props.onHostProfileSubmit(
      {
        home: {
          building_type: this.state.buildingType.val,
          features: this.state.features.val,
          features_other: this.state.featuresOther.val
        }
      }
    );
  }

  render() {
    const thisPage = P.HOUSE_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;
    
    return (
      <div id={page} className='profile'>
        <Redirector this_page={thisPage} page={page}/>
        <form>
          <FormHeader title={content.pages.house.title} icon={<Home />}/>
          <p>{content.pages.house.body}</p>

          <ProfileElementField
            childComponent={
              <SelectGroup
                title={formatMessage(defaultMessages.clientHostPagesHouseLabelsBuildingType)}
                setId={'buildingType'}
                placeholder={formatMessage(defaultMessages.clientHostPagesHouseFormBuildingTypesPrompt)}
                options={this.state.buildingTypeSelections}
                defaultValue={this.state.buildingType.val}
                valid={this.state.buildingType.valid}
                controlFunc={e => this.changeState(e.target.id, e.target.value)} />
            }
            elementName='building_type' />

          <ProfileElementField
            childComponent={
              <div>
                <CheckboxOrRadioGroup
                  title={formatMessage(defaultMessages.clientHostPagesHouseLabelsFeatures)}
                  setName={'features'}
                  type={'checkbox'}
                  controlFunc={this.handleFeature}
                  options={this.state.featureSelections}
                  selectedOptions={this.state.features.val}
                  valid={this.state.features.valid} />
                {
                  this.state.features.val.includes('Other') &&
                  <CustomFormGroup valid={this.state.featuresOther.valid}>
                    <FormControl
                      id='featuresOther'
                      type="text"
                      style={{width: '100%'}}
                      componentClass="input"
                      placeholder={formatMessage(defaultMessages.clientCommonDetails)}
                      defaultValue={this.state.featuresOther.val}
                      onChange={e => this.changeState(e.target.id, e.target.value)} />
                  </CustomFormGroup>
                }
              </div>
            }
            elementName='features' />

          <Alert alert={content.pages.house.info} />

          <ButtonGroup
            submitFunc={this.submit}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl} />
        </form>
      </div>
    );
  }
}

export default injectIntl(House);
